import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux'
import _ from 'lodash';
import styled from 'styled-components';
import { Link } from "react-router-dom";

import { V2_ACTIVE_COLOR, V2_BLACK_COLOR, V2_BUTTON_COLOR, V2_INACTIVE_COLOR, V2_POINT_COLOR } from '../config/color';
import { getItem } from '../utils/handleStorage';
import { getUser, saveUser } from '../redux/actions/userAction';
import { seller } from '../config/api';
// import { login } from '../redux/actions/authAction';
import Home from "../assets/image/Home.png";
import { Notice } from '../Components/Notice';
import numeral from 'numeral';
import SellerItemListTable from '../Components/SellerItemListTable';

const content = [
  {
    tab: "상점프로필",
  },
  {
    tab: "재고관리",
  },
  {
    tab: "대출관리",
  },
  {
    tab: "랭킹관리",
  },
  {
    tab: "실시간시세",
  },
  {
    tab: "노출수",
  },
];



const LeftTop = styled.div``;
const Image = styled.img``;
const ImageContainer = styled(Link)``;
const SLink = styled(Link)``;

const LeftBottom = styled.div``;
const LoginContainer = styled.div``;
const ServiceContainer = styled.div``;

const ButtonWrap = styled.div``;

const Wrap = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  position: relative;
`

const LeftWrap = styled.div`
  display: flex;
  /* flex: 2; */
  width: 380px;
  padding: 0 40px;
  /* height: 100%; */
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 768px) {
    display: none;
  }
`

const LeftContainer = styled.div`
  margin-top: 60px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${LeftTop} {
    width: 100%;
    margin-bottom: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    ${ImageContainer} {
      width: 100px;

      ${Image} {
        width: 100%;
      }
    }
  }

  ${LeftBottom} {
    width: 100%;
    margin-bottom: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    ${LoginContainer} {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      font-weight: 400;
      font-size: 20px;
      line-height: 30px;

      ${ButtonWrap} {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;

      }

      p {
        width: 100%;
        margin-bottom: 30px;
        &:is(:nth-child(3)) {
          margin-top: 0px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        span {
          display: inline-block;
          width: 100%;
          font-size: 16px;
          font-weight: 600;
          color: #6A7986;
          margin-bottom: 8px;
        }
        input {
          width: 100%;
          padding: 14px 20px;
          border-radius: 10px;

          ::placeholder {
            color: rgba(110, 117, 124, 0.3);
            font-size: 16px;
            line-height: 24px;
          }
        }
        button {
          background-color: ${V2_BUTTON_COLOR};
          border-radius: 16px;
          padding: 16px 24px;
          font-size: 20px;
          font-weight: 400;
          line-height: 24px;
          color: white;
          cursor: pointer;
        }
      }
    }

    ${ServiceContainer} {
      width: 100%;

      div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        ${SLink} {
          font-size: 12px;
          font-weight: 400;
          line-height: 20px;
          color: ${V2_ACTIVE_COLOR};
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          
          p {
            &:nth-child(1) {
              width: 16px;
              height: 18px;
              margin-right: 5px;
            }

            img {
              width: 100%;
            }
          }
        }
      }
    }
  }
`

const TabButton = styled.button`
  width: 100%;
  background-color: ${props => (props.tab ? 'white' : 'none')};
  color: ${props => (props.tab ? `${V2_BUTTON_COLOR}` : 'black')};
  font-weight: 600;
  font-size: 18px;
  padding: 18px 40px;
  border-radius: 10px;
  margin-bottom: 10px;
  text-align: left;
`;

const RightWrap = styled.div`
  display: flex;
  flex: 8;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: white;
`

const RightContainer = styled.div`
  margin-top: ${props => (props.index ? '60px' : '0px')};
  padding-left: ${props => (props.index ? '100px' : '0px')};
  padding-right: ${props => (props.index ? '100px' : '0px')};
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  @media (max-width: 768px) {
    padding-left: 0px;
    margin-top: 0px;
    padding: 30px 20px;
  }
`

const RightContainerSection = styled.div`
  margin-bottom: 60px;
  width: 100%;

  @media (max-width: 768px) {
    margin-bottom: 30px;
  }

  h2 {
    font-size: 24px;
  }

  h3 {
    margin-bottom: 30px;
    color: #74777E;
    font-size: 18px;
  }

  p {
    margin: 20px 0;
    color: ${V2_INACTIVE_COLOR};
    font-size: 16px;
    span {
      @media (max-width: 768px) {
        font-size: 12px;
      }
    }
  }
`

const SaveButton = styled.button`
  background-color: ${V2_BUTTON_COLOR};
  padding: 16px 24px;
  color: white;
  border-radius: 16px;
`

const InputWrap = styled.div`
  max-width: 400px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    margin-bottom: 20px;
  }

  &:is(:last-child) {
    margin-bottom: 0px;
  }
  
  label {
    display: block;
    color: #74777E;
    margin-bottom: 10px;
  }

  input {
    width: 100%;
    padding: 16px 24px;
    background-color: #EEEFF2;
    border-radius: 12px;
    margin-bottom: 10px;

    @media (max-width: 768px) {
      border-radius: 12px;
      padding: 16px 24px;
    }
    
    ::placeholder {
      color: #AEAEAE;
      font-size: 14px;
      line-height: 20px;
    }
  }
  span {
    display: inline-block;
    color: rgba(255, 110, 48, 0.8);
    line-height: 24px;
    @media (max-width: 768px) {
      font-size: 12px;
    }
  }
`;

const RadioInputWrap = styled.div`
  max-width: 400px;
  margin-bottom: 40px;
  &:is(:last-child) {
    margin-bottom: 0px;
  }
  
  label {
    display: block;
    color: #74777E;
    margin-bottom: 10px;
  }

  input {
    background-color: #EEEFF2;
    border-radius: 12px;
    margin-bottom: 10px;
    margin-right: 10px !important;

    ::placeholder {
      color: #AEAEAE;
      font-size: 14px;
      line-height: 20px;
    }
  }
  span {
    display: inline-block;
    color: rgba(255, 110, 48, 0.8);
    line-height: 24px;

    @media (max-width: 768px) {
      font-size: 12px;
    }
  }
`;

const NoticeText = styled.span`
  display: inline-block;
  color: rgba(255, 110, 48, 0.8);
  font-size: 12px;
  line-height: 18px;
`

const RowFlexStartCenter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`

const DetailPriceText = styled.p`
  font-size: 36px;
  font-weight: 600;
  color: ${V2_ACTIVE_COLOR};
  margin: 0px !important;
`

const DetailPriceTextSmall = styled.p`
  font-size: 18px;
  font-weight: 500;
  color: ${V2_ACTIVE_COLOR};
  padding-bottom: 4px;
  margin: 0px !important;
`

const TitleText = styled.h3`
  color: ${V2_BLACK_COLOR};
  font-size: 24px;
`

const Profile = ({history}) => {
  const dispatch = useDispatch();
  const [userInfo, setUserInfo] = useState({});
  const [sellerItemList, setSellerItem] = useState([]);
  const [sellerInfo, setSellerInfo] = useState({
    instagram: 0,
    blog: 0,
    blogAddress: null,
    instagramAddress: null,
    description: null
  });

  const useTabs = (initialTabs, allTabs) => {
    const [contentIndex, setContentIndex] = useState(initialTabs);

    return {
      contentItem: allTabs[contentIndex],
      contentChange: setContentIndex,
      contentIndex
    };
  };

  const { contentChange, contentIndex } = useTabs(0, content);

  const { description, instagramAddress, blogAddress } = sellerInfo;
  
  useEffect(() => {
    const initUserInfo = async () => {
      try {

        const token = await getItem('session');
        if (_.isNil(token)) {
          return history.push('/signin');
        }

        const user = await dispatch(getUser());
        setUserInfo(user?.data?.data);
        
        const sellerItems = await seller.sellerItemPriceHistory(user?.data?.data?.sellerId);
        setSellerItem(sellerItems?.data?.data);

        setSellerInfo({ 
          ...sellerInfo,
          instagramAddress: user?.data?.data?.Seller?.instagram,
          blogAddress: user?.data?.data?.Seller?.naverBlog,
          description: user?.data?.data?.Seller?.description,
        });

        // user의 state의 상태확인
      } catch (e) {
        alert(
          '유저 정보를 가져오는도중 오류가 발생하였습니다. 다시 로그인해주세요.',
        );
        return history.push('/signin')
      }
    }

    // setTimeout(() => {
      initUserInfo();
    // }, 1000)
    
  }, [setUserInfo, setSellerItem])

  const onChangeInput = useCallback( e => {
    const { name, value } = e.target;
    // if(e.target.type === 'radio') {
    //   setSeller({ ...seller, [name]: Number(value) });
    // } else {
      setSellerInfo({ ...sellerInfo, [name]: value });
    // }

  });

  const handleSubmit = useCallback( async () => {
    try {
      const result = await dispatch(saveUser(description, instagramAddress, blogAddress));
      if(result?.status === 200) {
        alert('정보 수정이 완료되었습니다.');
        window.location.reload();
      }
    } catch(e) {
      console.log(e)
    }

  }, [dispatch, description, instagramAddress, blogAddress])

  const loanRequest = async () => {
    try {
      const result = await seller.sellerRequestedLoan(userInfo?.sellerId);
      if(result?.status === 200) {
        alert('대출 상담 신청이 완료되었습니다. 곧 트레져러에서 연락을 드립니다.');
        window.location.reload();
      }

    } catch(e) {
      console.log(e)
    }
  }

  const sellerItemPrice = sellerItemList?.map((v) => v?.sellerItem?.price);
  const sellerTreasurerPrice = sellerItemList?.map((v) => v?.medianPrice[v?.medianPrice?.length - 1]);
  
  let priceList = [];
  sellerItemPrice?.map((v, i) => v !== 0 ? priceList.push(sellerItemPrice[i]) : sellerTreasurerPrice[i] === 'undefined' ? priceList.push(0) : priceList.push(sellerTreasurerPrice[i]) );
  

  const sellerProperty = sellerItemPrice?.length !== 0 && sellerItemPrice?.reduce((prev, curr) => prev + curr);
  const estimatedProperty = priceList?.length !== 0 && priceList?.reduce((prev, curr) => prev + curr);
  

  return (
    <Wrap>
      <LeftWrap>
        <LeftContainer>
          <LeftTop>
            <ImageContainer to="/">
              <Image src={Home} alt="logo" />
            </ImageContainer>
          </LeftTop>
          <LeftBottom>
            <LoginContainer>
              <ButtonWrap>
                {content.map((section, index) => (
                  <TabButton tab={contentIndex === index} onClick={() => contentChange(index)}>{section.tab}</TabButton>
                ))}
              </ButtonWrap>
            </LoginContainer>
          </LeftBottom>
        </LeftContainer>
      </LeftWrap>
      <RightWrap>
        <RightContainer index={contentIndex === 0}>
          {contentIndex === 0 && (
            // <ShopProfile />
            <>
              <RightContainerSection>
                <h2>
                  기본 프로필
                </h2>
                <p>
                  <span>많은 정보를 입력할 수록 더 믿을 수 있는 샵이 되어 랭킹반영에 가산점을 부여 받을 수 있습니다.</span>
                </p>
                <SaveButton onClick={() => handleSubmit()}>
                  저장하기
                </SaveButton>
              </RightContainerSection>
              <RightContainerSection>
                <h3>쇼핑몰 정보 입력</h3>
                <InputWrap>
                  <label>
                    쇼핑몰 이름
                  </label>
                  <input
                    placeholder={'쇼핑몰 이름을 입력하세요.'}
                    value={userInfo?.shopName}
                    disabled
                  />
                  <span>
                    * 변경을 원하시면 고객센터로 문의부탁드립니다.
                  </span>
                </InputWrap>
                <InputWrap>
                  <label>
                    쇼핑몰 사이트
                  </label>
                  <input
                    placeholder={'쇼핑몰 주소를 입력하세요.'}
                    value={userInfo?.shopUrl}
                    disabled
                  />
                  <span>
                    * 변경을 원하시면 고객센터로 문의부탁드립니다.
                  </span>
                </InputWrap>
                <InputWrap>
                  <label>
                    소개글 - 200자 이내 ( + 10점 )
                  </label>
                  <input
                    type={'text'}
                    name={'description'}
                    onChange={onChangeInput}
                    placeholder={'쇼핑몰을 소개해보세요'}
                    value={description}
                  />
                  <span>
                    상점의 소개글을 작성해보세요.
                  </span>
                </InputWrap>
              </RightContainerSection>
              <RightContainerSection>
                <h3>쇼핑몰 담당자 정보 입력</h3>
                <InputWrap>
                  <label>
                    이름
                  </label>
                  <input
                    placeholder={'담당자 성함을 입력해주세요.'}
                    value={userInfo?.shopClerkName}
                    disabled
                  />
                  <span>
                    * 변경을 원하시면 고객센터로 문의부탁드립니다.
                  </span>
                </InputWrap>
                <InputWrap>
                  <label>
                    휴대폰
                  </label>
                  <input
                    placeholder={'담당자의 휴대폰 번호를 입력해주세요.'}
                    value={userInfo?.shopPhoneNumber}
                    disabled
                  />
                  <span>
                    * 변경을 원하시면 고객센터로 문의부탁드립니다.
                  </span>
                  <span>
                    * 위 번호는 외부로 유출되지 않습니다.
                  </span>
                </InputWrap>
                <InputWrap>
                  <label>
                    유선전화
                  </label>
                  <input
                    placeholder={'매장 번호를 입력해주세요.'}
                    value={userInfo?.shopNumber}
                    disabled
                  />
                  <span>
                    * 변경을 원하시면 고객센터로 문의부탁드립니다.
                  </span>
                </InputWrap>
              </RightContainerSection>
              <RightContainerSection>
                <h3>자체 사이트/채널 보유 여부</h3>
                <RadioInputWrap>
                    <label>
                      쇼핑몰 공식 블로그 ( +5 점)
                    </label>
                    {!_.isNil(blogAddress) ? (
                      <span>
                        블로그 주소가 변경되었다면, 수정해주세요.
                      </span>
                    ) : (
                      <span>
                        블로그를 보유하고 있다면, 주소를 입력해주세요.
                      </span>
                    )}
                    {/* <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginTop: 10, marginBottom: 0}}>
                      <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 0}}>
                        <input style={{margin: 0}} type="radio" name="blog" value={0} onChange={onChangeInput} checked={blog === 0}/>
                        <span style={{color: '#AEAEAE'}}>미보유</span>
                      </div>
                      <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 0}}>
                        <input style={{margin: 0}} type="radio" name="blog" value={1} onChange={onChangeInput} checked={blog === 1} />
                        <span style={{color: '#AEAEAE'}}>보유</span>
                      </div>
                    </div> */}
                    {/* {blog ? ( */}
                    <div style={{marginBottom: 0, marginTop: 10}}>
                      <input
                        style={{padding: '16px 24px', width: '100%'}}
                        type="text"
                        name="blogAddress"
                        // onChange={e => setBlogAddress(e.target.value)}
                        onChange={onChangeInput}
                        placeholder={'블로그 주소를 입력해주세요.'}
                        value={blogAddress}
                      />
                    </div>
                </RadioInputWrap>
                <RadioInputWrap>
                    <label>
                      인스타그램 ( +5 점)
                    </label>
                    {!_.isNil(instagramAddress) ? (
                      <span>
                        인스타그램 주소가 변경되었다면, 수정해주세요.
                      </span>
                    ) : (
                      <span>
                        인스타그램을 보유하고 있다면, 주소를 입력해주세요.
                      </span>
                    )}
                    {/* <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginTop: 10, marginBottom: 0}}>
                      <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 0}}>
                        <input style={{margin: 0}} type="radio" name="instagram" value={0} onChange={onChangeInput} checked={instagram === 0}/>
                        <span style={{color: '#AEAEAE'}}>미보유</span>
                      </div>
                      <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 0}}>
                        <input style={{margin: 0}} type="radio" name="instagram" value={1} onChange={onChangeInput} checked={instagram === 1} />
                        <span style={{color: '#AEAEAE'}}>보유</span>
                      </div>
                    </div> */}
                    {/* {instagram ? ( */}
                      <div style={{marginBottom: 0, marginTop: 10}}>
                        <input
                          style={{padding: '16px 24px', width: '100%'}}
                          type="text"
                          name="instagramAddress"
                          // onChange={e => setinstagramAddress(e.target.value)}
                          onChange={onChangeInput}
                          placeholder={'인스타그램 주소를 입력해주세요.'}
                          value={instagramAddress}
                        />
                      </div>
                    {/* ) : null} */}
                </RadioInputWrap>
              </RightContainerSection>
              <RightContainerSection>
                <p>
                  <span style={{color: '#74777E'}}>
                    문의 : 02)1670-8051, 평일 09:00 - 18:00(토/일/공휴일 휴무, 점심 12:00 - 13:00)
                  </span>
                </p>
              </RightContainerSection>
            </>
          )}
          <RightContainer index={contentIndex === 1}>
            {contentIndex === 1 && (
              <>
              <RightContainerSection>
                <h2>
                  재고 관리
                </h2>
                <p>
                  <span>트레져러에 등록 되어있는</span>
                  <span style={{color: `${V2_POINT_COLOR}`}}>&nbsp;{userInfo?.shopName}&nbsp;</span>
                  <span>상점의 재고를 확인해보세요.</span>
                </p>
              </RightContainerSection>
              <RightContainerSection>
                <TitleText style={{fontSize: 24, color: `${V2_BLACK_COLOR}`}}>{userInfo?.shopName} 상점 자산</TitleText>
                <RowFlexStartCenter>
                  <div style={{marginRight: 20}}>
                    <h3>실제 자산</h3>
                    <div style={{display: 'flex', alignItems: 'flex-end'}}>
                      <DetailPriceText style={{fontSize: 36, color: `${V2_ACTIVE_COLOR}`}}>{numeral(sellerProperty).format('0,0')}</DetailPriceText>
                      <DetailPriceTextSmall>&nbsp;원&nbsp;</DetailPriceTextSmall>
                    </div>
                    <p>
                      <NoticeText>
                        업체에서 가격을 공개한 시계 가격들의 합입니다.
                      </NoticeText>
                    </p>
                  </div>
                  <div>
                    <h3>추정 자산</h3>
                    <div style={{display: 'flex', alignItems: 'flex-end'}}>
                      <DetailPriceText style={{fontSize: 36, color: `${V2_ACTIVE_COLOR}`}}>{numeral(estimatedProperty).format('0,0')}</DetailPriceText>
                      <DetailPriceTextSmall>&nbsp;원&nbsp;</DetailPriceTextSmall>
                    </div>
                    <p>
                      <NoticeText>
                        실제 재고 자산과 공개되지 않은 시계의 가격을 트레져러 가격으로 계산하여 합한 금액입니다.
                      </NoticeText>
                    </p>
                  </div>
                </RowFlexStartCenter>
              </RightContainerSection>
              <RightContainerSection>
                <TitleText style={{fontSize: 24, color: `${V2_BLACK_COLOR}`}}>시계 담보 대출 (월 금리 0.75%)</TitleText>
                <RowFlexStartCenter>
                  <div>
                    <h3>
                      담보 대출 가능 금액
                    </h3>
                    <div style={{display: 'flex', alignItems: 'flex-end', marginBottom: 10}}>
                      <DetailPriceText style={{fontSize: 36, color: `${V2_ACTIVE_COLOR}`}}>{numeral(estimatedProperty * 0.9).format('0,0')}</DetailPriceText>
                      <DetailPriceTextSmall>&nbsp;원&nbsp;</DetailPriceTextSmall>
                      <DetailPriceTextSmall>
                        <NoticeText style={{lineHeight: '0'}}>
                          (추정 자산의 90%)
                        </NoticeText>
                      </DetailPriceTextSmall>
                    </div>
                    <p style={{margin: '5px 0'}}>
                      <NoticeText style={{lineHeight: 'auto'}}>
                        트레져러에서는 파트너사에서게 총 재고 자산의 90%까지 재고 자산 담보 대출을 제공합니다.
                      </NoticeText>
                    </p>
                    <p style={{margin: '5px 0'}}>
                      <NoticeText style={{lineHeight: 'auto'}}>
                        월 0.75% 의 업계 최저 금리로 대출을 제공하고 있으니, 사업 확장 등 사업에 추가 자금이 필요하실 때 편하게 이용해보시기 바랍니다.
                      </NoticeText>
                    </p>
                    <div style={{marginTop: 30}}>
                      <SaveButton style={{marginBottom: 10}} onClick={() => loanRequest()}>
                        대출 상담하기
                      </SaveButton>
                      <p style={{margin: '5px 0'}}>
                        <NoticeText style={{lineHeight: 'auto'}}>
                          대출을 상담 버튼을 클릭하시면, 트레져러 담당자가 연락드립니다.
                        </NoticeText>
                      </p>
                      <p style={{margin: '5px 0'}}>
                        <NoticeText style={{lineHeight: 'auto'}}>
                          * 버튼 클릭시, 실제로 대출이 이루어지는 것이 아닙니다.
                        </NoticeText>
                      </p>
                    </div>
                  </div>
                </RowFlexStartCenter>
              </RightContainerSection>
              <RightContainerSection>
                <TitleText style={{fontSize: 24, color: `${V2_BLACK_COLOR}`}}>트레져러에 등록된 {userInfo?.shopName} 상점 재고 현황</TitleText>
                <p style={{margin: '5px 0'}}>
                  <NoticeText style={{lineHeight: 'auto'}}>
                    * 트레져러는 유동성이 풍부하고 인기가 많은 시계를 시작으로 다양한 시계 데이터를 제공할 예정입니다.
                  </NoticeText>
                </p>
                <p style={{margin: '5px 0'}}>
                  <NoticeText style={{lineHeight: 'auto'}}>
                    롤렉스를 시작으로 타 브랜드의 시계도 지속적으로 업데이트할 예정이며, 국내에서 판매되는 대부분의 명품 시계를 취급할 예정입니다
                  </NoticeText>
                </p>
                <SellerItemListTable sellerItemList={sellerItemList} />
              </RightContainerSection>
            </>
            )}
          </RightContainer>
          {contentIndex > 1 && (
            <Notice active={false} />
          )}
        </RightContainer>
      </RightWrap>
    </Wrap>
  )

}

export default Profile;